import { EPrivateRoutes } from "@core-types/routes.enum";
import { useAppNavigate } from "@hooks/language/useAppNavigate";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Group } from "@mantine/core";
import { ELoginModalState } from "@store/loginModal.store";
import useLoginModalStore from "@store/loginModal.store";
import useUserStore from "@store/user.store";
import { Trans } from "react-i18next";
import SSProgress, { EProgressColor } from "./Progress";
import UseMyCoinsButton from "./UseMyCoinsButton";
import ContainerCard, {
  type IContainerCardProps,
} from "./container/ContainerCard";
import ContainerText from "./container/ContainerText";

interface INextUserRewardProps {
  containerProps?: IContainerCardProps;
  coinAmount?: number;
  displayButton?: boolean;
}
const NEXT_REWARDS_COINS = 100;

const NextUserRewardCard: React.FC<INextUserRewardProps> = ({
  containerProps,
  coinAmount: coinAmount_,
  displayButton = false,
}) => {
  const { affiliationInformation, isLogin } = useUserStore();
  const { navigate } = useAppNavigate();
  const { open } = useLoginModalStore();
  const coinAmount = coinAmount_ ?? affiliationInformation?.coinBalance ?? 80;
  const isNextRewardReached = NEXT_REWARDS_COINS - coinAmount <= 0;

  const { t } = useAppTranslation("pages.clientDashboard.components");

  return (
    <ContainerCard title={t("nextUserRewardCard.title")} {...containerProps}>
      <SSProgress
        value={coinAmount}
        maximum={NEXT_REWARDS_COINS}
        variant={
          isNextRewardReached ? EProgressColor.SUCCESS : EProgressColor.GOLD
        }
      />
      <Group wrap="nowrap">
        <ContainerText className="text-center">
          {isNextRewardReached ? (
            t("nextUserRewardCard.reachedText")
          ) : (
            <Trans
              i18nKey="pages.clientDashboard.components.nextUserRewardCard.notReachedText"
              values={{
                amount: NEXT_REWARDS_COINS - coinAmount,
              }}
              components={{
                1: <span className="font-bold text-gold-gradient-start" />,
              }}
            />
          )}
        </ContainerText>
        {displayButton && (
          <UseMyCoinsButton
            className="min-w-[170px]"
            onClick={() =>
              isLogin
                ? navigate(EPrivateRoutes.REWARDS)
                : open(ELoginModalState.LOGIN)
            }
          />
        )}
      </Group>
    </ContainerCard>
  );
};

export default NextUserRewardCard;
